//estado inicial del componente
const initialState = {
  open: false,
  message: ""
};
//creamos el reducer
const openMessageReducer = (state = initialState, action) => {
  switch (action.type) {
    case "OPEN_SNACKBAR":
      return {
        ...state,
        open: action.openMessage.open,
        message: action.openMessage.message
      };
    default:
      return state;
  }
};

export default openMessageReducer;
